"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.OutlineManager = void 0;
const THREE = __importStar(require("three"));
class OutlineManager {
    // #endregion Properties (2)
    // #region Constructors (1)
    constructor(_renderingEngine) {
        this._renderingEngine = _renderingEngine;
        this._outlineNodes = [];
    }
    // #endregion Constructors (1)
    // #region Public Methods (5)
    addSelection(node) {
        this._outlineNodes.push(node);
        this.updateOutlineEffectObjects();
    }
    clearSelection() {
        this._outlineNodes = [];
        this.updateOutlineEffectObjects();
    }
    removeSelection(node) {
        const index = this._outlineNodes.indexOf(node);
        if (index !== -1) {
            this._outlineNodes.splice(index, 1);
            this.updateOutlineEffectObjects();
            return true;
        }
        return false;
    }
    setEffect(outlineEffect) {
        this._outlineEffect = outlineEffect;
        this.updateOutlineEffectObjects();
    }
    updateOutlineEffectObjects() {
        this._outlineEffect.selection.clear();
        const objects = [];
        for (let i = 0; i < this._outlineNodes.length; i++) {
            this._outlineNodes[i].convertedObject[this._renderingEngine.id].traverse((o) => {
                if (o instanceof THREE.Mesh)
                    objects.push(o);
            });
        }
        this._outlineEffect.selection.set(objects);
    }
    selectedNodes() {
        return this._outlineNodes;
    }
}
exports.OutlineManager = OutlineManager;
//# sourceMappingURL=OutlineManager.js.map